import React, { useState, useEffect } from 'react';
import SwipeableViews from 'react-swipeable-views'; //paquete installado manual(npm i react-swipeable-views)
import { makeStyles, useTheme } from '@material-ui/core/styles';
import styles from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import SpZone from 'components/Tvendo/Sale/DataMaster/Supervisor/SupervisorDetail/SpZone';
import SpBureau from 'components/Tvendo/Sale/DataMaster/Supervisor/SupervisorDetail/SpBureau';
import SpSeller from 'components/Tvendo/Sale/DataMaster/Supervisor/SupervisorDetail/SpSeller';

import SweetAlert from 'react-bootstrap-sweetalert';
import { useParams, useSearchParams } from 'react-router-dom';

import { Toasty, useToasty } from 'hooks/Toasty';
import { wsRemove, wsUpdate } from 'services/WService.js';

//Tabs
import { TabPanel, indexTab, useStyleTabs } from 'hooks/TabPanel';
import SupervisorTracking from 'components/Tvendo/Sale/DataMaster/Supervisor/SupervisorDetail/SupervisorTracking';
import { wsPost } from 'services/WService';
import { LayerProvider } from 'contexts/layerContext';
import moment from 'moment';
import { wsFindBy } from 'services/WService';
import { TextField } from '@material-ui/core';

const useStyles = makeStyles(styles);

export default function () {
  const classes = useStyles();
  const themeTab = useTheme();
  const [searchParams] = useSearchParams();

  const claseStyleTab = useStyleTabs();
  const { id } = useParams();
  const [value, setValue] = useState(0);
  const [date, setDate] = useState(searchParams.get('date') || moment().format('YYYY-MM-DD'));
  const [notify, showNotify] = useToasty();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleChangeIndex = (index) => {
    setValue(index);
  };

  //#region --- funcion para mostrar alert de confirmacion al eliminar
  const [alert, setAlert] = useState(null);
  const hideAlert = () => {
    setAlert(null);
  };
  function confirmAction(entity, id, data = undefined) {
    setAlert(
      <SweetAlert
        warning
        style={{ display: 'block', marginTop: '-100px' }}
        title={data === undefined ? '¿Está seguro de eliminar?' : '¿Está seguro de actualizar?'}
        onConfirm={() => {
          if (data === undefined) {
            remove(entity, id);
          } else {
            if(data.portfolio == 'Y'){
              
              updatePortfolioSellerBureau(entity, id, data);
            
            }else{
              updateState(entity, id, data);
            }
          }

          hideAlert();
        }}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + ' ' + classes.success}
        cancelBtnCssClass={classes.button + ' ' + classes.danger}
        confirmBtnText="Aceptar"
        cancelBtnText="Cancelar"
        showCancel
      >
        {data === undefined ? '' : data.portfolio === 'Y' ? 'El supervisor asumirá la cartera del vendedor seleccionado.'
          : '¡Esta acción afecta a las Mesas y Vendedores!'}
      </SweetAlert>,
    );
  }

  async function remove(entity, id) {
    let response = await wsRemove(entity, id);
    if (response.success) {
      showNotify(response.message);
      getSupervisor();
    } else {
      showNotify(response.message, 'error');
    }
  }
  //#endregion

  //#region --- Actualizar estado de los hijos
  async function updateState(entity, id, data) {
    let response = await wsUpdate('base/supervisor/' + supervisor.id + '/' + entity, id, data);
    if (response.success) {
      showNotify(response.message);
      getSupervisor();
    } else {
      showNotify(response.message, 'error');
    }
  }
  async function updatePortfolioSellerBureau(entity, id, data) {
    let response = await wsUpdate('base/supervisor/' + supervisor.id + '/' + entity + '/portfolio-seller', id, data);
    if (response.success) {
      showNotify(response.message);
      getSupervisor();
    } else {
      showNotify(response.message, 'error');
    }
  }

  async function regenerate() {
    let res = await wsPost(`base/supervisor/${id}/regen`);
    if (res.success) {
      showNotify(res.message);
      await getSupervisor();
    } else {
      showNotify(res.message, 'error');
    }
  }
  //#endregion

  const [supervisor, setSupervisor] = useState({ routes: [] });

  async function getSupervisor() {
    let response = await wsFindBy(`base/supervisor/${id}`, { date });
    if (response.success) {
      let routes = response.data.routes.map((route) => {
        if (route.geometry !== null) {
          route.geometry = route.geometry.value.map((polygon) => {
            return polygon.map((point) => ({
              lng: point[0],
              lat: point[1],
            }));
          });
        }
        return route;
      });
      setSupervisor({ ...response.data, routes });
    }
  }

  const tabsComponent = [
    { component: SpZone, label: 'Zonas' },
    { component: SpBureau, label: 'Mesas' },
    { component: SpSeller, label: 'Vendedores' },
    { component: SupervisorTracking, label: 'Seguimiento' },
  ];

  useEffect(() => {
    getSupervisor();
  }, [date]);

  return (
    <LayerProvider>
      <Toasty action={notify} />
      {alert}
      <>
        <div>
          <h4 style={{ fontWeight: 'bold' }}>{supervisor.name}</h4>

          <TextField
            type="date"
            label="Fecha"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
          />
        </div>

        <div className={claseStyleTab.root}>
          <AppBar position="static" color="default">
            <Tabs
              value={value}
              onChange={handleChange}
              variant="scrollable"
              scrollButtons="auto"
              textColor="secondary"
              aria-label="Tabs"
              indicatorColor="secondary"
            >
              {!!supervisor ? (
                tabsComponent.map((item, i) => {
                  return <Tab key={i} label={item.label} {...indexTab(i)} />;
                })
              ) : (
                <></>
              )}
            </Tabs>
          </AppBar>
          <SwipeableViews
            axis={themeTab.direction === 'rtl' ? 'x-reverse' : 'x'}
            index={value}
            onChangeIndex={handleChangeIndex}
          >
            {!!supervisor ? (
              tabsComponent.map((item, i) => {
                return (
                  <TabPanel key={item.label} value={value} index={i} dir={themeTab.direction}>
                    <item.component
                      supervisor={supervisor}
                      reload={getSupervisor}
                      showNotify={showNotify}
                      confirmDelete={confirmAction}
                      updateState={confirmAction}
                      updatePortfolioSellerBureau={confirmAction}
                      regenerate={regenerate}
                    />
                  </TabPanel>
                );
              })
            ) : (
              <></>
            )}
          </SwipeableViews>
        </div>
      </>
    </LayerProvider>
  );
}
